(async function () {
  async function loadCodes() {
    if (!window.__ENTRYCODES_URL__) return {};
    const res = await fetch(window.__ENTRYCODES_URL__, { cache: "no-store" });
    if (!res.ok) return {};
    return await res.json();
  }

  function init(codes) {
    const dateInput = document.getElementById("EntryDate");
    const codeInput = document.getElementById("EntryCode");
    if (!dateInput || !codeInput) return;

    const addBtn =
      document.querySelector('button[name="add"]') ||
      document.querySelector('button[type="submit"]');

    function update() {
      const date = dateInput.value; // YYYY-MM-DD
      const code = codes[date] || "";
      codeInput.value = code;
      if (addBtn) addBtn.disabled = !code;
    }

    dateInput.addEventListener("change", update);
    update();
  }

  try {
    const codes = await loadCodes();
    init(codes);
  } catch (e) {
    console.error("Entrycodes error:", e);
  }
})();
